// extracted by mini-css-extract-plugin
export default {"termsContainer":"Terms_termsContainer__e-je8","heading":"Terms_heading__9IQCO","date":"Terms_date__X0oA2"};